import { InjectionToken } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, Auth } from 'firebase/auth';
import { environment } from '@env/environment';

const firebaseApp = initializeApp(environment.firebase);
getAnalytics(firebaseApp);

export const AUTH = new InjectionToken<Auth>('firebase.auth', {
    providedIn: 'root',
    factory: () => getAuth(firebaseApp),
});
